import { IRoadmap } from "@/shared/types/roadmap";
import { RootState } from "@/store/redux/store";
import { useState } from "react";
import { useSelector } from "react-redux";

function useBSI() {
    const busStation = useSelector((state: RootState) => state.mapScreen.busStation);
    const [roadmaps, setRoadmaps] = useState<IRoadmap[] | undefined>();
    const [loading, setLoading] = useState<boolean>(false);
    
    return ({
        roadmaps,
        loading,
        busStation,
    })
}

export default useBSI;